  import { createReducer, on, union } from '@ngrx/store';
  import * as CourseActions from './course.actions';
  import { CourseState } from './course.state';
  import { ICourse } from '../models/course.model';
  import { ILesson } from '../models/lesson.model';

  export const initialCourseState: CourseState = {
    learningCourse: {} as ICourse,
    currentLesson: {} as ILesson
  };

  export const courseReducer = createReducer(
      initialCourseState,

      on( CourseActions.getCourseActivitySuccess, (state , { learningCourse }) => ({
        ...state,
        learningCourse: learningCourse
      })),

      on( CourseActions.setCurrentLesson, (state , { lessonId }) => ({
          ...state,
          currentLesson:
            state.learningCourse.courseModules?.flatMap(x => x.lessons).find(y => y.id == lessonId)!
      })),

      on( CourseActions.setCurrentLessonStatusSuccess, (state , { course, lessonId }) => ({
          ...state,
          learningCourse: course,
          currentLesson: course.courseModules?.flatMap(x => x.lessons).find(y => y.id == lessonId)!
      })),

      on( CourseActions.clearCurrentLesson, (state) => ({
        ...state,
        currentLesson: {} as ILesson
      }))


  );
